<div *ngIf="!mobile && showProfileMenu"
  class="border_customize_card border-2 z-50 my-4 text-base list-none card_color rounded-lg shadow-lg block"
  style="position: absolute; top: 60px; right: 10px;">
  <div class="pt-2 pb-1 px-4" role="none">
    <p class="text-md text_color_customize font-medium" role="none">
      {{ userName }}
    </p>
  </div>
  <ul class="p-2 text_white" role="none">
    <li class="mb-2" *ngIf="showSecondProfileMenu">
      <a (click)="openLobby()"
        class="duration-200 flex items-center px-2.5 text-sm font-normal text_white hover:text_black rounded-lg group button_color_customize hover:button_color_customize transition-all py-3">
        <div class="text_color_customize hover:text_black group-hover:text_black">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-home">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
            <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
            <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
          </svg>
        </div>
        <span class="ml-2 ease-in-out font-medium">Lobby</span>
      </a>
    </li>
    <li class="mb-2" *ngIf="!showSecondProfileMenu">
      <a (click)="!isPCPlayer && openProfile()"
        class="duration-200 flex items-center px-2.5 text-sm font-normal text_white hover:text_black rounded-lg group button_color_customize hover:button_color_customize transition-all py-3">
        <div class="text_color_customize group-hover:text_black">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-user-hexagon">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M12 13a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z"></path>
            <path d="M6.201 18.744a4 4 0 0 1 3.799 -2.744h4a4 4 0 0 1 3.798 2.741"></path>
            <path
              d="M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z">
            </path>
          </svg>
        </div>
        <span class="ml-2 ease-in-out font-medium">Perfil</span>
      </a>
    </li>
    <li>
      <a (click)="logout()"
        class="duration-200 flex items-center px-2.5 text-sm font-normal text_white hover:text_black rounded-lg group button_color_customize hover:button_color_customize transition-all py-3">
        <div class="text_color_customize group-hover:text_black">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-logout">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2">
            </path>
            <path d="M9 12h12l-3 -3"></path>
            <path d="M18 15l3 -3"></path>
          </svg>
        </div>
        <span class="ml-2 ease-in-out font-medium">Cerrar Sesión</span>
      </a>
    </li>
  </ul>
</div>


<div *ngIf="mobile && showProfileMenu" class="card_color rounded-xl my-2 w-full py-6 px-4 text_white">
  <h2 class="text-md font-semibold mb-4 text-left ml-1">Perfil</h2>

  <!-- User Menu Dropdown -->

  <div class="pt-2 pb-1 mb-3" role="none">
    <p class="text-md text_color_customize font-medium" role="none">
      {{ userName }}
    </p>
  </div>

  <ul class="text_white" role="none">
    
    <li class="mb-2" *ngIf="showSecondProfileMenu">
        <a (click)="openLobby()"
            class="transition-all duration-200 flex items-center px-2.5 text-sm font-normal text_white hover:text_black rounded-lg group button_color_customize hover:button_color_customize transition-all py-3">
            <div class="text_color_customize hover:text_black group-hover:text_black">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-home">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
                    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
                    <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
                </svg>
            </div>
            <span class="ml-2 ease-in-out font-medium">Lobby</span>
        </a>
    </li>
    <li class=" mb-2" *ngIf="!showSecondProfileMenu">
      <a (click)="!isPCPlayer && openProfile()"
        class="transition-all duration-200 flex items-center px-4 text-sm font-normal text_white hover:text_black rounded-lg group button_color_customize hover:button_color_customize transition-all py-3">
        <div class="text_color_customize group-hover:text_black">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-user-hexagon">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 13a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z" />
            <path d="M6.201 18.744a4 4 0 0 1 3.799 -2.744h4a4 4 0 0 1 3.798 2.741" />
            <path
              d="M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z" />
          </svg>
        </div>
        <span class="ml-2 ease-in-out font-medium">Perfil</span>
      </a>
    </li>
    <li>
      <a (click)="logout()"
        class="transition-all duration-200 flex items-center px-4 mb-2 text-sm font-normal text_white hover:text_black rounded-lg group button_color_customize hover:button_color_customize transition-all py-3">
        <div class="text_color_customize group-hover:text_black">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-logout">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
            <path d="M9 12h12l-3 -3" />
            <path d="M18 15l3 -3" />
          </svg>
        </div>
        <span class="ml-2 ease-in-out font-medium">Cerrar Sesión</span>
      </a>
    </li>
  </ul>
</div>